import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const checkAuthPath = '/api/admin/check-auth';
  const clientAccesPath = '/admin-page';

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(checkAuthPath, {
          method: 'GET',
          credentials: 'include',
        });
        const data = await response.json();
        setIsAuthenticated(data.isAuthenticated);
      } catch (error) {
        console.error('Auth check error:', error);
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, [checkAuthPath]);

  if (isAuthenticated === null) {
    return <div role="status" aria-live="polite" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            Loading...
          </div>;
  }

  return isAuthenticated ? children : <Navigate to={clientAccesPath} replace/>;
};

export default ProtectedRoute;